import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEventType, HttpResponse, HttpParams } from '@angular/common/http';
import { MissingData } from '../models/missingdata.model';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { resetComponentState } from '@angular/core/src/render3/state';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  private Url: string;
  private missingData: BehaviorSubject<MissingData>;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.Url = baseUrl;
    this.missingData = new BehaviorSubject<MissingData>(JSON.parse(localStorage.getItem('missingData')));

  }

  public get missingDataList(): MissingData {
    return this.missingData.value;
  }

  getMissingData() {
    return this.http.get(this.Url + 'api/file/getMissingData')
  }

  uploadFile(formData, isPhoneFile, fileName, cutoffDate) {
    let params = new HttpParams().set("isPhoneFile", isPhoneFile.toString())
      .append('fileName', fileName.toString())
      .append('cutoffDate', cutoffDate.toString()); //,"fileName"
    return this.http.post(this.Url + 'api/file/loadFile', formData, {
      params: params,
      reportProgress: true,
      observe: 'events'
    }
    ).pipe(map(respuesta => {
      return respuesta
    }))
  }

  uploadFileDevolution(formData) {
    return this.http.post(this.Url + 'api/file/loadFileDevolution', formData, {
      reportProgress: true,
      observe: 'events'
    }
    ).pipe(map(respuesta => {
      return respuesta
    }))
  }

  uploadFilePayments(formData) {
    console.log("babosadas");
    return this.http.post(this.Url + 'api/file/loadFilePayments', formData, {
      reportProgress: true,
      observe: 'events'
    }
    ).pipe(map(respuesta => {
      return respuesta
    }))
  }

  uploadFileCancellations(formData) {
    return this.http.post(this.Url + 'api/file/loadFileCancellations', formData, {
      reportProgress: true,
      observe: 'events'
    }
    ).pipe(map(respuesta => {
      return respuesta
    }))
  }
  downloadFeedbackP_C(fileName: string, payment: boolean) {
    let params = new HttpParams().set("Namefile", fileName);
    let urlMethod = payment ? 'api/file/getDownloadFilePayment' : 'api/file/getDownloadFileCancellations'
    return this.http.get(this.Url + urlMethod, { params: params, responseType: 'blob' })
    .subscribe((blob: Blob) => {
      console.log('report is downloaded');

      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, fileName);
      }
      else {
        let link = document.createElement("a");
        if (link.download !== undefined) {
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        else {
          //html5 download not supported
        }
      }
    });
}
  downloadFeedback(fileName: string) {
    let params = new HttpParams().set("Namefile", fileName);
    return this.http.get(this.Url + 'api/file/getDownloadFile', { params: params, responseType: 'blob' })
      .subscribe((blob: Blob) => {
        console.log('report is downloaded');

        if (navigator.msSaveBlob) {
          // IE 10+
          navigator.msSaveBlob(blob, fileName);
        }
        else {
          let link = document.createElement("a");
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          else {
            //html5 download not supported
          }
        }
      });
  }

  getCountRegisters() {
    return this.http.get(this.Url + 'api/file/getCountRegisters');
  }

  setMissingData(Data: MissingData) {
    localStorage.setItem('missingData', JSON.stringify(Data));
  }

  checkStep(position: number, Data: MissingData) {
    let result: boolean;
    switch (position) {
      case 0:
        if (Data.listMissingCities && Data.listMissingCities.length > 0) {

          result = true ;

        } else if (Data.listMissingOffices && Data.listMissingOffices.length > 0) {

          result =true ;

        } else if (Data.listMissingAgents && Data.listMissingAgents.length > 0) {           
          
          result = true ;

        } else {

          result = false;

        }
        break;
      case 1:
        if (Data.listMissingOffices && Data.listMissingOffices.length > 0 ) {
          //console.log("1. Hay sucursales");
          result = true;

        } else if (Data.listMissingAgents && Data.listMissingAgents.length > 0) {

          result =  true ;
          //console.log("1. Hay agentes");
        } else {
          result = false;
        }
        //result = this.missingDataList.listMissingOffices.length > 0 ? this.missingDataList.listMissingAgents.length > 0 ? true : false : false;
        //console.log(result)
        break;
      case 2:
        //console.log(position)
        if (Data.listMissingAgents && Data.listMissingAgents.length > 0) {          //console.log("2. Hay agentes");
          result =  true ;
        } else {
          result = false;
        }
        //result = this.missingDataList.listMissingAgents.length > 0 ? true : false ;
        //console.log(result)
        break;
      default:
        //console.log(position)
        result = false;
        //console.log(result)
        break;
    }
    return result
  }



}
